import { createGlobalStyle } from 'styled-components';

export const PrintReset = createGlobalStyle`
    @page {
      size: A4 landscape;
      margin: 10mm;
    }

    @media print {
      .backbone-container {
        display: none !important;
      }

      html {
        body.critical-error-present.payment-error {
          padding-top: 0 !important;
          padding: 0 !important;

          .notice-bar, #NotificationCenter {
            display: none !important;
          }

          main {
            padding-top: 0 !important;
          }
        }

        body.v2-app.critical-error-present.payment-error #v2 {
          padding-top: 0 !important;
        }
      }

      body {
        padding-top: 0 !important;
        padding: 0 !important;
      }

      body.v2-app {
        padding-top: 0 !important;

        #v2 {
          background: #fff !important;
          height: auto !important;
          overflow: visible !important;
          padding-top: 0 !important;
        }

        main {
          position: static !important;
        }

        #dropdown-root, #modal-root {
          display: none !important;
        }
      }

      ._pendo-badge {
        display: none !important;
      }

      #left-sidebar {
        display: none !important;
      }

      .notice-bar {
        display: none !important;
      }

      .toast-container {
        display: none !important;
      }

      body {
        padding: 0;
        padding-top: 0 !important;
      }
    }

`;
